<template>
  <div class="h-100">
    <template v-if="userStore.authenticated">
      <slot name="menu">
        <template v-if="$vuetify.display.xs">
          <layout-main-app-bar />
          <layout-main-drawer />
          <layout-mobile-app-bar name="mobile-app-bar-plain" />
        </template>
        <template v-else>
          <layout-main-drawer />
          <layout-main-app-bar />
        </template>

        <layout-content-menu v-if="showContentMenu" />
        <layout-product-filter-menu v-else-if="productFiltersVisible" />
        <layout-pdf-content-menu v-else-if="showPdfContentMenu" />
      </slot>
    </template>
    <v-main class="h-100" :scrollable="$vuetify.display.xs">
      <layout-search-container v-if="userStore.authenticated" />

      <div class="h-100">
        <slot></slot>
      </div>
    </v-main>

    <LayoutSnackBar />
    <StudentWheelModal v-if="userStore.isTeacherWithActiveSchoolAndProPlan" />
    <StudentGroupsModal v-if="userStore.isTeacherWithActiveSchoolAndProPlan" />
    <TeacherTimerModal v-if="userStore.isTeacherWithActiveSchoolAndProPlan" />
    <StickyBoardModal v-if="userStore.isTeacherWithActiveSchoolAndProPlan" />
    <StickyBoardStudentRequest v-if="userStore.isStudent" />
  </div>
</template>

<script>
import { contentMenuVisible, pdfContentMenuVisible, productFiltersVisible } from "~/helpers/index"
import { useUserStore } from "~/stores/userStore"

export default {
  setup() {
    const userStore = useUserStore()

    return {
      userStore,
    }
  },

  computed: {
    showContentMenu() {
      return contentMenuVisible(this.$route)
    },

    productFiltersVisible() {
      return productFiltersVisible(this.$route)
    },

    showPdfContentMenu() {
      return pdfContentMenuVisible(this.$route)
    },
  },
}
</script>
